import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import SstPastPrepayments from "./SstPastPrepayments";

export default {
    storageKey: StorageKey.report_sst_current_prepayments,
    getReportLabel: () => t`Service Tax for Current Prepayments`,
    required: SstPastPrepayments.required,
    defaulto: SstPastPrepayments.defaulto,
    getColumns: SstPastPrepayments.getColumns,
};
